export default __webpack_public_path__ + "dedab654b407786bbe9a1387db18bd95.svg";